<div 
  *ngIf="showTooltip && tooltipText"
  class="timeline--fullscreen-tooltip"
  [style.left.px]="tooltipPosition.x"
  [style.top.px]="tooltipPosition.y"
>
  {{ tooltipText }}
</div>
